import { Link } from "gatsby";
import React from "react";
import { getMember } from "../../actions/miscAction";
import FetchImage from "./fetchImage";
const Logo = ({ newHeader, desktopHeight, mobHeight }) => {
  const customizedDashboard = typeof window !== "undefined" && JSON.parse(localStorage.getItem("customization"));
  const isDynamicLogo =
    typeof window !== "undefined" &&
    (window.location.pathname.includes("/my-account/") || window.location.pathname.includes("/members/post-listing/"))
      ? true
      : false;

  return !newHeader ? (
    <a className="navbar-brand" href="/">
      <img
        style={{ maxHeight: desktopHeight }}
        class="d-none d-lg-block"
        src={
          customizedDashboard?.dashboard_logo && isDynamicLogo && customizedDashboard?.show_custom_dashboard
            ? process.env.GATSBY_MEDIA_URL + "/" + customizedDashboard?.dashboard_logo
            : process.env.GATSBY_IMAGE_URL + "logo.svg"
        }
        alt="logo"
      />
      <img
        style={{ maxHeight: mobHeight }}
        class="d-block d-lg-none"
        src={
          customizedDashboard?.dashboard_logo && isDynamicLogo && customizedDashboard?.show_custom_dashboard
            ? process.env.GATSBY_MEDIA_URL + "/" + customizedDashboard?.dashboard_logo
            : process.env.GATSBY_IMAGE_URL + "logo.svg"
        }
        alt="logo"
      />
    </a>
  ) : (
    <a className="navbar-brand" href="/">
      <img
        style={{ maxHeight: desktopHeight }}
        class="d-none d-lg-block customized-header-logo"
        src={
          customizedDashboard?.dashboard_logo && isDynamicLogo && customizedDashboard?.show_custom_dashboard
            ? process.env.GATSBY_MEDIA_URL + "/" + customizedDashboard?.dashboard_logo
            : process.env.GATSBY_IMAGE_URL + "salvex-logo-new-white.svg"
        }
        alt="logo"
      />
      <img
        style={{ maxHeight: mobHeight }}
        class="d-block d-lg-none customized-header-logo-mob"
        src={
          customizedDashboard?.dashboard_logo && isDynamicLogo && customizedDashboard?.show_custom_dashboard
            ? process.env.GATSBY_MEDIA_URL + "/" + customizedDashboard?.dashboard_logo
            : process.env.GATSBY_IMAGE_URL + "salvex-logo-new-white.svg"
        }
        alt="logo"
      />
    </a>
  );
};

export default Logo;
